<template>
  <div>
    <v-row class="mt-4 mx-4">
      <v-col col2="12" md="2">
        <date-picker label="From" v-model="fromDate"></date-picker>
      </v-col>
      <v-col col2="12" md="2">
        <date-picker label="To" v-model="toDate"></date-picker>
      </v-col>
      <v-col col2="12" md="2">
        <v-btn color="primary" class="mt-4" dark @click="refresh">
          <v-icon>mdi-refresh </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col col="12">
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Time</th>
                <th class="text-left">User</th>
                <th class="text-left">Type</th>
                <!-- <th class="text-left">School Session</th> -->
                <th class="text-left">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in auditList" :key="item.id">
                <td>{{ format(new Date(item.timestamp * 1000), 'PP p') }}</td>
                <td>{{ getUser(item) }}</td>
                <td>{{ recordTypes[item.recordType] }}</td>
                <!-- <td>{{ item.username }}</td> -->
                <td>{{ item.description }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { GET_AUDIT_HISTORY } from '@/store/modules/System/actions';
import { format, subDays } from 'date-fns';
import DatePicker from '@/components/DatePicker.vue';

export default {
  name: 'Audit',
  inject: ['eventHub'],
  components: { DatePicker },
  data() {
    return {
      format,
      auditList: [],
      fromDate: '',
      toDate: '',
      recordTypes: {
        2: 'Location',
        3: 'Depot',
        4: 'Stop',
        5: 'Driver',
        6: 'Vehicle',
        10: 'User',
        12: 'Address',
        26: 'Semester',
        29: 'Vehicle Type',
        99: 'Backup',
        100: 'Config',
        300: 'Admin',
        301: 'Trip Request',
        302: 'Trip Type',
        303: 'Trip Event',
        304: 'Destination',
        305: 'Budget Code',
        306: 'Funding Source',
        310: 'Approval Level',
        311: 'Approver',
        320: 'Assignment',
        322: 'Vehicle Type',
        324: 'Additional Transportation',
        350: 'Config',
        201: 'Role',
        400: 'Sync',
      },
    };
  },
  computed: {
    ...mapGetters('user', ['me', 'usersByEmail', 'usersById']),
  },
  mounted() {
    this.fetchItems();
  },
  methods: {
    ...mapActions('system', [GET_AUDIT_HISTORY]),
    ...mapActions('user', ['getUsers']),
    async fetchItems() {
      this.toDate = format(new Date(), 'MMM d, yyyy');
      this.fromDate = format(subDays(new Date(), 7), 'MMM d, yyyy');
      await this.getUsers();
      this.refresh();
    },
    async refresh() {
      this.auditList = await this.getAuditHistory({ fromDate: this.fromDate, toDate: this.toDate });
    },
    getUser(item) {
      if (item.userId === 0) return 'System';
      else if (item.userId) return `${this.usersById[item.userId].displayName}  (${this.usersById[item.userId].email})`;
      else if (item.username) return `${this.usersByEmail[item.username].displayName}  (${item.username})`;
    },
  },
  watch: {},
};
</script>

<style lang="scss"></style>
